var render = function render(_c,_vm){return _c('div',{attrs:{"id":"CampaignNotesManualNote"}},[(typeof _vm.props.note.notes === 'string')?[_vm._v(" "+_vm._s(_vm.$options.methods.parseSimpleNote(_vm.props.note.notes))+" ")]:[_vm._v(" "+_vm._s(_vm.$options.methods.parseSimpleNote(_vm.props.note.notes.note))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }